export const APP_NAME = '24Horas';
export const APP_SHORT_NAME = '24Horas';
export const APP_DESCRIPTION = 'O seu jornal diário online. Todas as notícias sobre a actualidade nacional e internacional.';

export const APP_VERSION = '1.3.12';
export const APP_BUILD_NUMBER = 10312;

/** Public contact details required for Google Play News & Magazines policy */
export const APP_WEBSITE_URL = 'https://24horas.pt';
export const APP_CONTACT_URL = 'https://24horas.pt/contactos';
export const APP_CONTACT_EMAIL = 'geral@24horas.pt';
export const APP_CONTACT_ADDRESS = 'Rua General Ferreira Martins, 6D, 1497-305 Miraflores';
